"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoWalletConnectionService = void 0;
var web3_1 = __importDefault(require("web3"));
var web3_utils_1 = require("web3-utils");
// TODO : FUTURE : O.L : Change all ethereum.<call> to the new standard events format.
//                        Consider using AbstractProvider
var CryptoWalletConnectionService = /** @class */ (function () {
    function CryptoWalletConnectionService(ethereum) {
        this.ethereum = ethereum;
        this.hasEthereumProvider = this.ethereum !== undefined;
        // Distinguishes between installed ethereum providers
        this.isMetamaskInstalled =
            this.hasEthereumProvider && !!this.ethereum.isMetaMask;
        this.isSemiCompliantEthereumProviderInstalled =
            this.hasEthereumProvider && !this.ethereum.isMetaMask;
        if (this.hasEthereumProvider) {
            this.web3 = new web3_1.default(this.ethereum);
        }
        var onFunction = this.hasEthereumProvider ? this.ethereum.on : undefined;
        this.hasEventsSupport = onFunction !== undefined && onFunction !== null;
    }
    CryptoWalletConnectionService.prototype.requestConnectionPermission = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.ethereum.enable()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CryptoWalletConnectionService.prototype, "didUserApproveDappInThePast", {
        // Getters
        get: function () {
            // DEV_NOTE : O.L : IMPORTANT ! : This currently works with the soon to be deprecated apis of metamask injected 'ethereum'
            //                                and is not part of the properties in the official types of web3.
            //                                We need to check and find a better way to detect if the user has already approved wallet access.
            // @ts-ignore
            return this.isMetamaskInstalled && !!this.ethereum.selectedAddress;
        },
        enumerable: false,
        configurable: true
    });
    CryptoWalletConnectionService.prototype.getIsMainNetwork = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.isMetamaskInstalled && this.ethereum.networkVersion === "1"];
            });
        });
    };
    // Data "reading"
    CryptoWalletConnectionService.prototype.readEthereumBalance = function (address) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var balance, balanceInDecimal;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.web3) === null || _a === void 0 ? void 0 : _a.eth.getBalance(address))];
                    case 1:
                        balance = _b.sent();
                        balanceInDecimal = parseInt(web3_utils_1.fromWei(balance || "0"));
                        return [2 /*return*/, balanceInDecimal];
                }
            });
        });
    };
    CryptoWalletConnectionService.prototype.readMainAddress = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var accounts;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.web3) === null || _a === void 0 ? void 0 : _a.eth.getAccounts())];
                    case 1:
                        accounts = (_b.sent()) || [];
                        return [2 /*return*/, accounts[0]];
                }
            });
        });
    };
    CryptoWalletConnectionService.prototype.readCurrentBlockNumber = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, ((_a = this.web3) === null || _a === void 0 ? void 0 : _a.eth.getBlockNumber()) || 0];
            });
        });
    };
    // Event listeners
    CryptoWalletConnectionService.prototype.onMainAddressChange = function (onChange) {
        var _this = this;
        if (!this.hasEventsSupport) {
            throw new Error("Cannot subscribe to events with given Ethereum provider");
        }
        var listener = function (accounts) { return onChange(accounts[0]); };
        this.ethereum.on("accountsChanged", listener);
        return function () {
            _this.ethereum.off("accountsChanged", listener);
        };
    };
    return CryptoWalletConnectionService;
}());
exports.CryptoWalletConnectionService = CryptoWalletConnectionService;
//# sourceMappingURL=CryptoWalletConnectionService.js.map